import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { MotivoDevolucionModalAddEditComponent } from './modal-add-edit/modal-add-edit.component';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { MotivoDevolucionService } from 'src/app/services/motivo-devolucion.service';
import * as _ from "lodash";
  
@Component({
  selector: 'app-motivos-devolucion',
  templateUrl: './motivos-devolucion.component.html',
  styleUrls: ['./motivos-devolucion.component.scss'],
  providers: [SecurityService],
})
export class MotivosDevolucionComponent implements OnInit {
  // Constants
  readonly RB_ESTADO_ACTIVOS: Number = 1
  readonly RB_ESTADO_INACTIVOS: Number = 2
  readonly RB_ESTADO_TODOS: Number = 3
  @ViewChild(MotivoDevolucionModalAddEditComponent, { static: true }) modalAddEditMotivoDevolucion: MotivoDevolucionModalAddEditComponent
  // Form
  formHeader: FormGroup

  // Data &  Tmp
  private rutEmpresa: number
  private sucursalCodigo: number
  listaMovimientos: any = null
  listaMovimientosAll: any = null
  inputParams: any = null
  paginationContext: PaginationContext = new PaginationContext()
  loading: boolean = false
  currentPayload: any

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private rutService: RutService,
    private messageRendererService: MessageRendererService,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private motivoDevolucionService: MotivoDevolucionService,
  ) {
    this.log = this.clog.log('MOTIVOS')
  }

  ngOnInit() {
    this.createForm()
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10
    //this.loadOperaciones()
  }

  private createForm() {
    this.formHeader = this.fb.group({
      busquedaEstado: [this.RB_ESTADO_ACTIVOS,  [Validators.required]],
      descripcion: ['']
    });
  }

  openModalMotivo() {
    this.modalAddEditMotivoDevolucion.show()
  }

  buscar(pageNumber: number = 1) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    this.paginationContext.CurrentPage = pageNumber

    this.listaMovimientos = []
    this.listaMovimientosAll = []
    this.loading = true

    const { descripcion, busquedaEstado } = this.formHeader.value
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        descripcion,
        tipobusqueda: busquedaEstado
      },
      paginaActual: 1, //this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1, //this.paginationContext.RecordsByPage
    }
    this.currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.motivoDevolucionService.obtenerSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        return
      }

      const { registros } = respuesta

      this.listaMovimientosAll = registros

      this.paginationContext.RecordsCount = this.listaMovimientosAll.length //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
      // this.paginationContext.CurrentPage = 1

      this.listaMovimientosAll.forEach((detalle, index) => {
        delete detalle.__typename
        detalle.additionalInfo = {
          index,
          cantidad_valid: true
        }
      })

      this.loading = false
      this.showPage(this.paginationContext.CurrentPage)
      //this.log('data', JSON.stringify(this.listaMovimientosAll))
    })
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.listaMovimientos = _.slice(this.listaMovimientosAll, start, start + this.paginationContext.RecordsByPage)
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage)
  }

  editar(motivo) {
    this.modalAddEditMotivoDevolucion.load(motivo)
  }

  onAddEdit(motivo) {
    this.buscar()
  }

  desactivar({ codigo, empresa_rut, sucursal_codigo }) {
    const inputParams = {
      entidad: {
        codigo,
        empresa_rut,
        sucursal_codigo,
        activo: false
      }
    }
    this.cambiarEstado(inputParams)
  }

  activar({ codigo, empresa_rut, sucursal_codigo }) {
    const inputParams = {
      entidad: {
        codigo,
        empresa_rut,
        sucursal_codigo,
        activo: true
      }
    }
    this.cambiarEstado(inputParams)
  }

  cambiarEstado(inputParams) {
    this.motivoDevolucionService.cambiaEstado(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.toastrService.success('Operación realizada con éxito')
      this.buscar()
    })
  }
}
